import { AxiosError } from 'axios';

export function isAxiosError<T>(error: unknown): error is AxiosError<T> {
  return Boolean(typeof error === 'object' && error && 'isAxiosError' in error);
}
